import type { MediumProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

const Medium = (props: MediumProps) => {
  return <LazyComponent<MediumProps> name="Medium" {...props} />;
};

export default Medium;
